import {
  MEDIA_TYPE,
  useConfigStore,
  useTracksStore,
} from '@cometchat/calls-sdk-core';
import Audio from './Audio.web';

/**
 * Renders audio elements for all remote participants.
 */
const RemoteAudioRenderer = () => {
  const tracks = useTracksStore(state => state.tracks);
  const enableCompanionMode = useConfigStore(
    state => state.enableCompanionMode,
  );

  if (enableCompanionMode) {
    return null;
  }

  const remoteAudioTracks = tracks.filter(
    track =>
      track.mediaType === MEDIA_TYPE.AUDIO &&
      !track.local &&
      track.originalTrack,
  );

  return (
    <>
      {remoteAudioTracks.map((audioTrack, index) => (
        <Audio
          key={audioTrack.originalTrack.getId?.() || index}
          id={`cc-rt-${audioTrack.originalTrack.getId?.() || ''}`}
          audioTrack={audioTrack.originalTrack}
        />
      ))}
    </>
  );
};

export default RemoteAudioRenderer;
